import React from 'react'

type ChevronDownIconProps = React.SVGProps<SVGSVGElement>

const ChevronDownIcon: React.FC<ChevronDownIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20" // Using 20x20 viewbox like heroicons/20/solid
    fill="currentColor" // Defaulting to fill like heroicons solid variant
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z"
      clipRule="evenodd"
    />
  </svg>
)

export default ChevronDownIcon
